export default "__VITE_ASSET__qlu$U1ol__"